import { useLocation } from "react-router-dom";
import VideoGuides from "./videoGuides";
import TechSupport from "./techSupport";
import SetupGuide from "./setupGuide";
import SpeedTest from "./speedTest";
import About from "./about";
import {
  ProfileAccountInfo,
} from "api/interfaces/accountInterface.interface";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import { useAppSelector } from "redux/hooks";
import Contact from "./contact";

type Props = {};

export default function Help(props: Props): JSX.Element {
  const location = useLocation();
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );

  if (
    location.pathname.includes("techsupport") &&
    selectedAccount.accountLevel === LEVEL_TYPE.CP
  )
    return <TechSupport />;
  if (
    location.pathname.includes("contact") &&
    selectedAccount.parentLevel === LEVEL_TYPE.CP
  )
    return <Contact />;
  if (location.pathname.includes("setupguide")) return <SetupGuide />;
  if (location.pathname.includes("speedtest")) return <SpeedTest />;
  if (location.pathname.includes("about")) return <About />;
  else return <VideoGuides />;
}
